(() => {
  if (window.__F24MobileQuickCartFix) return;
  window.__F24MobileQuickCartFix = true;

  document.addEventListener(
    'submit',
    (event) => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const productForm = form.closest('product-form');
      if (!productForm) return;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (!cart) return;
      if (typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') return;

      productForm.cart = cart;
    },
    true
  );
})();
